import DeviceListContainer from './DeviceListContainer';
export default DeviceListContainer;
